/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'vs-logs';
const componentName = 'vs-log-policy-grid';
const prefix = `${moduleName}.${componentName}`;

export const sslLabel = `${prefix}.sslLabel`;
export const icapLabel = `${prefix}.icapLabel`;
export const botManagementLabel = `${prefix}.botManagementLabel`;
export const datascriptLabel = `${prefix}.datascriptLabel`;
export const policiesAppliedLabel = `${prefix}.policiesAppliedLabel`;

export const ENGLISH = {
    [sslLabel]: 'SSL',
    [datascriptLabel]: 'Datascript',
    [icapLabel]: 'ICAP',
    [botManagementLabel]: 'Bot Management',
    [policiesAppliedLabel]: 'Policies Applied',
};
